import React, { FC } from 'react';

import { PageContext, PageContextValue } from './context';

export interface PageContextProviderProps {
  readonly value: PageContextValue;
}

const PageContextProvider: FC<PageContextProviderProps> = (props) => <PageContext.Provider {...props} />;

export default PageContextProvider;
